import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
export const host = `${process.env.REACT_APP_API_URL}`;
